import React from 'react';

import { SectionLabel } from './SectionLabel';
import {
  PrioritySelectItem,
  PrioritySelectMenu,
} from '../../../../components/molecules/PrioritySelectMenu';

export interface PriorityFieldProps {
  value: string;
  items: PrioritySelectItem[];
  onChange: (value: string) => void;
  validate: boolean;
  disabled: boolean;
  error?: string;
  lockReason?: string;
  locked?: boolean;
}

export const PriorityField: React.FC<PriorityFieldProps> = ({
  value,
  items,
  onChange,
  validate,
  disabled,
  error,
  lockReason,
  locked,
}) => (
  <SectionLabel label="Priority" required helper={error} lockReason={lockReason} locked={locked}>
    <PrioritySelectMenu
      id="create-service-priority"
      label="Priority"
      value={value}
      items={items}
      onChange={onChange}
      validate={validate && !value}
      disabled={disabled || !!lockReason || !!locked}
      hideInlineLabel
    />
  </SectionLabel>
);
